import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {useEvents} from "../../../lib/useEvents";

export function useDeleteSirenDefaultBroadcastConfig() {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const deleteConfig = useCallback(async (id: string, context?: {clientID?: string; departmentID?: string}) => {
        setDeleting(true);
        setError(null);
        try {
            await platformAPI.delete(`api/siren/default-broadcast-config/${id}`);
            emit("siren:broadcastConfig:changed", {clientID: context?.clientID, departmentID: context?.departmentID, deleted: true});
        } catch {
            setError("Failed to delete default broadcast config");
            throw new Error("Failed to delete default broadcast config");
        } finally {
            setDeleting(false);
        }
    }, []);

    return {deleteConfig, deleting, error};
}
